'use client'

import { envService } from '@/core/services/env'
import { PayPalScriptProvider } from '@paypal/react-paypal-js'

const CLIENT_ID = envService.get('PAYPAL_CLIENT_ID')

interface PaypalProviderProps {
  currency?: string
  children: React.ReactNode
}

export const PaypalProvider: React.FC<PaypalProviderProps> = ({
  currency,
  children,
}) => {
  const locale = 'en_US' // TODO add locale

  return (
    <PayPalScriptProvider
      options={{
        clientId: CLIENT_ID,
        currency: currency || 'USD',
        locale,
      }}
    >
      {children}
    </PayPalScriptProvider>
  )
}
